import * as Yup from "yup";

export const schoolSchema = Yup.object().shape({
  title: Yup.string()
    .required("Please provide the school's name.")
    .min(3, "The school's name must have at least 3 caractors."),
  language: Yup.string().required(
    "Please select the related language for the school."
  ),
  description: Yup.string().required("Provide the school's description."),
});
export const streamSchema = Yup.object().shape({
  title: Yup.string()
    .required("The stream's name is required")
    .min(5, "The stream's name must have at least 5 caractors"),
  language: Yup.string().required(
    "Please select the related language for the stream"
  ),
  description: Yup.string().required("The stream's description is required"),
});
